export default "__VITE_ASSET__FjUlCNIn__"